import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  message,
  Row,
  Space,
  Spin,
  Tooltip,
  Upload,
} from "antd";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import {
  getDanToc,
  getNation,
  getNoiCap,
  getPhongBanAPI,
  getTonGiao,
  getWord,
  searchRecruiment,
} from "../../../../../../redux/reducer/employee";
import { field } from "./config";
import { employeeService } from "api";
import { InputFields } from "../../../../../../components/common";
import { FIELD_TYPE, FORMAT_TIME } from "../../../../../../types/enums";
import { PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";
import diagnose from "../../../../../../api/diagnose";
import Notification from "../../../../../../components/common/notification/notification";
import Icons from "../../../../../../assets/icons";
import { DataFormField } from "types/models/input-field-type";
import { listClassification, listGender } from "data/list";
const {
  INPUT,
  DATE,
  COMBO_BOX,
  AUTO_COMPLETE,
  CURRENCY,
  NUMBER,
  DATE_PRE,
  DATE_DISABLE_NO_DAY,
  SELECT,
} = FIELD_TYPE;
const FormAdd = (props) => {
  const handleNoiCap = (e) => {
    const noiCapValue = form.getFieldValue("noiCap");
    // console.log("noiCapValue",noiCapValue);
    const selectedNoiCap = employees.noiCap.find(
      (item) => item.noiCap === noiCapValue
    );
    // console.log(employees.noiCap);

    //console.log("selectedNoiCap", selectedNoiCap);
    if (selectedNoiCap) {
      form.setFieldsValue({ noiCapTA: selectedNoiCap.noiCapTA });
    }
    //  console.log(form.getFieldValue("noiCap"));
  };
  const handleDiaChiLamViec = (e) => {
    const diaChi = form.getFieldValue("diaChiLamViec");
    const selectedDiaChi = employees.wordAddress.find(
      (item) => item.diaChiLamViec === diaChi
    );
    // console.log(selectedDiaChi);
    if (selectedDiaChi) {
      form.setFieldsValue({ diaChiLamViecTA: selectedDiaChi.diaChiLamViecTA });
    }
  };
  const listYears = [];
  const currentYear = new Date().getFullYear();
  const startYear = 1950;
  const endYear = currentYear + 150;
  for (let year = startYear; year <= endYear; year++) {
    listYears.push({
      value: year,
      label: year.toString(),
    });
  }
  const listMarriage = [
    {
      value: "0",
      label: "Chưa kết hôn",
    },
    {
      value: "1",
      label: "Sống chung chưa kết hôn",
    },
    {
      value: "2",
      label: "Đang có vợ/chồng",
    },
    {
      value: "3",
      label: "Góa",
    },
    {
      value: "4",
      label: "Ly thân",
    },
    {
      value: "5",
      label: "Ly hôn",
    },
  ];
  const listNoiCap = [
    {
      value: "Sở Công an",
      label: "Sở Công An",
    },
    {
      value:
        "Cục cảnh sát đăng ký quản lý cư trú và dữ liệu quốc gia về dân cư",
      label:
        "Cục cảnh sát đăng ký quản lý cư trú và dữ liệu quốc gia về dân cư",
    },
    {
      value: "Cục cảnh sát quản lý hành chính về trật tự xã hội",
      label: "Cục cảnh sát quản lý hành chính về trật tự xã hội",
    },
  ];
  const dataFields: DataFormField[] = [
    {
      type: SELECT,
      label: "Đợt tuyển dụng",
      name: "idDotTuyenDung",
      disable: false,
      rules: [{ required: true, message: "Chưa nhập đợt tuyển dụng" }],
    },
    {
      type: COMBO_BOX,
      name: "viTriUngTuyen",
      label: "Vị trí ứng tuyển",
      disable: false,
    },
    {
      type: INPUT,
      name: "hoTen",
      label: "Họ tên",
      disable: false,
      rules: [{ required: true, message: "Chưa nhập họ và tên" }],
    },
    {
      type: INPUT,
      name: "viTriUngTuyenTA",
      label: "Vị trí ứng tuyển TA",
      disable: false,
    },
    {
      type: DATE_DISABLE_NO_DAY,

      name: "ngaySinh",
      label: "Ngày sinh",
      disable: false,
      disableDate: false,
      optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    },
    {
      type: COMBO_BOX,
      name: "gioiTinh",
      label: "Giới tính",
      disable: false,
      options: listGender,
    },
    {
      type: INPUT,
      name: "hoKhauThuongTru",
      label: "Hộ khẩu thường trú",
      disable: false,
    },
    {
      type: INPUT,
      name: "nguyenQuan",
      label: "Nguyên quán",
      disable: false,
    },
    {
      type: COMBO_BOX,

      name: "quocTich",
      label: "Quốc tịch",
      disable: false,
      disableDate: false,
    },
    {
      type: INPUT,

      name: "nuocCuTru",
      label: "Nước cư trú",
      disable: false,
      disableDate: false,
    },
    {
      type: INPUT,

      name: "dienThoaiDiDong",
      label: "Điện thoại",
      disable: false,
      disableDate: false,
      // rules: [
      //   {
      //     validator: validatePhoneNumber,
      //   },
      // ],
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
        {
          max: 11,
          min: 10,
          message: "Định dạng SĐT không đúng",
        },
      ],
    },
    {
      type: INPUT,
      name: "email",
      label: "Email",
      disable: false,
      rules: [
        {
          pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
          message: "Định dạng email không đúng",
        },
      ],
    },
    {
      type: INPUT,
      name: "cccd",
      label: "Số CMT/CCCD/Hộ chiếu",
      disable: false,
    },
    {
      type: DATE_DISABLE_NO_DAY,
      name: "ngayCap",
      label: "Ngày cấp",
      disable: false,
      optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    },
    {
      type: COMBO_BOX,
      label: "Địa chỉ làm việc",
      name: "diaChiLamViec",
      disable: false,
      expand: false,
      onChange: handleDiaChiLamViec,
    },
    {
      type: COMBO_BOX,
      name: "noiCap",
      label: "Nơi cấp ",
      onChange: handleNoiCap,
      disable: false,
      //  options: listNoiCap,
      css: {
        xl: 16,
        lg: 12,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
      wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
    },
    {
      type: COMBO_BOX,
      label: "Địa chỉ làm việc TA",
      name: "diaChiLamViecTA",
      disable: false,
      expand: false,
    },
    {
      type: COMBO_BOX,
      name: "noiCapTA",
      label: "Nơi cấp TA",
      disable: false,
      // options: listNoiCap,
      css: {
        xl: 16,
        lg: 12,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
      wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
    },
    {
      type: COMBO_BOX,
      name: "danToc",
      label: "Dân tộc",
      disable: false,
    },
    {
      type: SELECT,
      name: "tonGiao",
      label: "Tôn giáo",
      disable: false,
    },
    {
      type: COMBO_BOX,
      name: "tinhTrangHonNhan",
      label: "TT hôn nhân",
      disable: false,
      options: listMarriage,
    },
    {
      type: INPUT,
      name: "ngonNgu",
      label: "Ngôn ngữ",
      disable: false,
    },
    {
      type: CURRENCY,
      name: "mucLuong",
      label: "Mức lương",
      disable: false,
    },
    {
      type: DATE_DISABLE_NO_DAY,
      name: "ngayNopHoSo",
      label: "Ngày nộp hồ sơ",
      disable: false,
      optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    },
    {
      type: COMBO_BOX,
      name: "trinhDo",
      label: "Trình độ",
      disable: false,
      options: [
        {
          value: "Đại học",
          label: "Đại học",
        },
        {
          value: "Cao đẳng",
          label: "Cao đẳng",
        },
        {
          value: "Chưa xác định",
          label: "Chưa xác định",
        },
      ],
    },
    {
      type: INPUT,
      name: "totNghiepTruong",
      label: "Tốt nghiệp trường",
      disable: false,
      css: {
        xl: 16,
        lg: 12,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
      wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
    },
    {
      type: COMBO_BOX,
      name: "namTotNghiep",
      label: "Năm tốt nghiệp",
      disable: false,
      options: listYears,
    },
    {
      type: COMBO_BOX,
      name: "xepLoai",
      label: "Xếp loại",
      disable: false,
      options: listClassification,
      css: {
        xl: 16,
        lg: 12,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
      wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
    },
    {
      type: INPUT,
      name: "ghiChu",
      label: "Ghi chú",
      disable: false,
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 4, xl: 2 },
      wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },
    },
    {
      type: INPUT,
      name: "fileCV",
      label: "CV đính kèm",
      disable: false,
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 4, xl: 2 },
      wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },
    },
  ];

  const { data, closeModal, type, getListApi, setCurrentPage } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const employees = useAppSelector((state) => state.employeesReducer);
  const [id, setId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();
  const [fieldInfo, setFieldInfo] = useState(dataFields);
  const [fieldStates, setFieldStates] = useState(field);
  useEffect(() => {
    form.resetFields();
  }, []);
  useEffect(() => {
    dispatch(
      searchRecruiment({
        page: 1,
        limit: 100,
      })
    );
    dispatch(
      getWord({
        page: 1,
        limit: 1000,
      })
    );
    dispatch(getDanToc());
    dispatch(getNation());
    dispatch(getTonGiao());
    dispatch(getNoiCap());
    form.setFieldValue("nuocCuTru", "Việt Nam");
  }, []);
  useEffect(() => {
    // Set field options for all necessary fields
    const setOptionsFields = (list, fieldName, valueKey, labelKey) => {
      const field = fieldInfo.find((field) => field.name === fieldName);
      if (field) {
        field.options = list?.map((item) => ({
          value: item[valueKey],
          label: item[labelKey],
        }));
        setFieldInfo([...fieldInfo]);
      }
    };

    // Update options based on employees data
    if (employees.RecruimentList) {
      setOptionsFields(
        employees.RecruimentList,
        "idDotTuyenDung",
        "id",
        "tenDotTuyenDung"
      );
      setOptionsFields(
        employees.RecruimentList,
        "viTriUngTuyen",
        "chucVu",
        "chucVu"
      );
    }
    if (employees.tonGiaoList) {
      setOptionsFields(employees.tonGiaoList, "tonGiao", "name", "name");
    }
    if (employees.quocTichList) {
      setOptionsFields(employees.quocTichList, "quocTich", "nameVN", "nameVN");
    }
    if (employees.danTocList) {
      setOptionsFields(employees.danTocList, "danToc", "name", "name");
    }
    if (employees.wordAddress) {
      setOptionsFields(
        employees.wordAddress,
        "diaChiLamViec",
        "diaChiLamViec",
        "diaChiLamViec"
      );
    }
    if (employees.noiCap) {
      setOptionsFields(employees.noiCap, "noiCap", "noiCap", "noiCap");
    }
  }, [
    employees.RecruimentList,
    employees.tonGiaoList,
    employees.quocTichList,
    employees.danTocList,
    employees?.noiCap,
  ]);
  const addApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
      };
      const res = await employeeService
        .updateCandidateDirectory(params)
        .then((res) => {
          setId(res.data.id);
          closeModal();
          Notification(
            "success",
            "Đã thêm mới ứng viên thành công thành công "
          );
          form.resetFields();
        });
      setLoading(false);
      await getListApi({});
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi thêm thông tin ứng viên");
    }
  };
  const getViTri = async (id) => {
    try {
      const res = await employeeService.getRecruitment(id);
      const viTri = res.data.chucVu;
      viTri === null ? "_" : form.setFieldValue("viTriUngTuyen", viTri);
    } catch (error) {
      Notification("error", error);
    }
  };
  useEffect(() => {
    fieldInfo.find((e) => e.name == "idDotTuyenDung").onChange = (e) => {
      getViTri(e);
    };
    setFieldInfo([...fieldInfo]);
  }, []);
  useEffect(() => {
    const updatedFieldTT = dataFields.map((field) => {
      if (
        field.name === "fileCV" ||
        field.name === "viTriUngTuyen" ||
        field.name === "noiCapTA" ||
        field.name === "diaChiLamViecTA"
      ) {
        return {
          ...field,
          disable: true,
        };
      } else {
        return {
          ...field,
          disable: false,
        };
      }
    });
    const updatedFieldKQ = field.map((field) => ({
      ...field,
      disable: false,
    }));
    setFieldInfo(updatedFieldTT);
    setFieldStates(updatedFieldKQ);
  }, []);

  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];
      const formData = new FormData();
      formData.append("pdfFiles", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload CV");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileCandidateDirectory(
            formData,
            id
          );
          if (response.status == 200) {
          }
          setLoading(false);
          closeModal();
          await getListApi({});
          form.setFieldValue("fileCV", pdf.name);
          Notification("success", "tải lên file cv thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file cv");
      }
    }
  };
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const onFinish = (values) => {
    addApi();
  };
  return (
    <div style={{ marginTop: 10 }}>
      <Spin spinning={loading}>
        <Form form={form}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row gutter={[16, 16]}>
              <InputFields data={fieldInfo}></InputFields>
              <Col xl={2} lg={2}>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUpload}
                    ref={fileInputRef}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick}
                    style={{
                      width: "130px",
                      border: "1px solid #00B335", // Đặt màu viền xanh
                      color: "#00B335", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Upload CV
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={fieldStates}></InputFields>
            </Row>
            <Row justify="end" style={{ marginTop: 12 }}>
              <Col>
                <Space>
                  <Button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "red",
                      borderColor: "red",
                      color: "white",
                    }}
                  >
                    Hủy bỏ
                  </Button>
                  <Button htmlType="submit" type="primary" onClick={onFinish}>
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default FormAdd;
